import { Dropdown } from "primereact/dropdown"
import { useField } from "formik"

import { Skeleton } from "primereact/skeleton"

import CustomTooltip from "../../pages/Kiosk/Admin/Utils/CustomTooltip"

//Style
import styles from "../../styles/Form-Inputs.module.css"
import kioskStyles from "../../styles/kiosk/KioskAdmin.module.css"

export default function FormikDropDown({
  name,
  label,
  options,
  optionLabel,
  optionValue,
  helpText,
  helpIcon,
  placeHolderValue,
  disabled,
  showClear,
  required,
  isInitialLoad,
  onChangeCallback,
  filter,
  itemTemplate,
  valueTemplate,
}) {
  const [field, meta, helpers] = useField(name)
  const getDropDown = () => {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      return (
        <>
          <Dropdown
            value={field.value}
            name={name}
            options={options}
            optionLabel={optionLabel}
            optionValue={optionValue}
            disabled={disabled}
            showClear={showClear}
            filter={filter}
            placeholder={
              !placeHolderValue ? `Please select an entry` : placeHolderValue
            }
            onChange={(e) => {
              helpers.setValue(e.value)

              if (!!onChangeCallback) {
                onChangeCallback(e.value)
              }
            }}
            className={meta.touched && meta.error ? "p-invalid" : undefined}
            style={{ width: "100%" }}
            itemTemplate={itemTemplate}
            valueTemplate={valueTemplate}
          />
          {meta.touched && meta.error ? (
            <label id={`${name}-error`} className={styles.errFieldMsg}>
              {meta.error}
            </label>
          ) : null}
        </>
      )
    }
  }

  const labelField = () => {
    if (isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return (
        <>
          {helpIcon && (
            <CustomTooltip
              label={helpText}
              position={"right"}
              targetId={name}
            />
          )}
          <label>
            {label}{" "}
            {required ? <span style={{ color: "red" }}> * </span> : null}
            {helpIcon && (
              <i
                className={`pi pi-info-circle ${kioskStyles.info}`}
                id={name}
              ></i>
            )}
          </label>
        </>
      )
    }
  }

  return (
    <div className={styles.field}>
      <label>{labelField()}</label>
      <div>
        {helpText && !helpIcon ? (
          <div style={{ marginBottom: "10px" }}>
            <small style={{ color: "gray" }}>{helpText}</small>
          </div>
        ) : null}
        {getDropDown()}
      </div>
    </div>
  )
}
